var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"select2",attrs:{"id":_vm.id,"multiple":_vm.multiple,"disabled":_vm.disabled,"placeholder":_vm.placeholder}},[_c('option'),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }